module.exports = __webpack_public_path__ + "img/prova.9f1c4dfe.jpg";